import Sidebar from "../components/Sidebar";
import { useEffect, useState } from "react";
import StatisticTable from "../components/common/StatisticTable";
import { fetchWorkloadData } from "utils/fetchWorkloadData";
import { Select } from "components/Select/Select";
import Spinner from "components/Spinner";
import { checkObject } from "shared/checkObject";
import { workspaceCountView } from "components/common/WorkspaceCountView";
import { projectsSlashWorkspaces } from "components/common/projectsSlashWorkspaces";
import { TableViewSwapper } from "components/TableViewSwapper";

function Workload() {
  // Получаем текущий год
  const currentYear = new Date().getFullYear();
  const startYear = 2023;

  // Создаем объект values
  const years = {
    values: {}
  };

  // Заполняем годами от 2023 до текущего
  for (let year = startYear; year <= currentYear; year++) {
    years.values[year] = year.toString();
  }

  const [isLoading, setIsLoading] = useState(false);
  const [workloadData, setWorkloadData] = useState([]);
  const [finalWorkspaceCount, setFinalWorkspaceCount] = useState(0);
  const [totalWorkspaceCount, setTotalWorkspaceCount] = useState(0);
  const [inProgressWorkspaceCount, setInProgressWorkspaceCount] = useState(0);
  const [agreementWorkspaceCount, setAgreementWorkspaceCount] = useState(0);
  const [inProgressPercentage, setInProgressPercentage] = useState(0);
  const [agreementPercentage, setAgreementPercentage] = useState(0);
  const [finishedPercentage, setFinishedPercentage] = useState(0);
  const [unassignedTotalWorkspaceCount, setUnassignedTotalWorkspaceCount] =
    useState(0);
  const [selectedYear, setSelectedYear] = useState(
    years.values[currentYear.toString()]
  );
  const [currentView, setCurrentView] = useState('workload_by_stage');


  const getWorkloadData = async () => {
    setIsLoading(true);
    await fetchWorkloadData(selectedYear, setWorkloadData);
    setIsLoading(false);
  };

  useEffect(() => {
    getWorkloadData();
  }, [selectedYear]);


  useEffect(() => {
    setUnassignedTotalWorkspaceCount(
      valueHandler(
        workloadData[
          workloadData?.findIndex((x) => x.title === "Неназначенное")
        ]?.pkUnassignedCount?.workspaceCount
      ) +
      valueHandler(
        workloadData[
          workloadData.findIndex((x) => x.title === "Неназначенное")
        ]?.soutUnassignedCount?.workspaceCount
      ) +
      valueHandler(
        workloadData[
          workloadData.findIndex((x) => x.title === "Неназначенное")
        ]?.oprUnassignedCount?.workspaceCount
      )
    );

    setFinalWorkspaceCount(
      workloadData.reduce((res, project) => {
        return (res += valueHandler(
          project?.finish?.allSummed?.workspaceCount
        ));
      }, 0)
    );
    setInProgressWorkspaceCount(
      workloadData.reduce((res, project) => {
        const baseSum =
          valueHandler(project?.readyToWork?.allSummed?.workspaceCount || 0) +
          valueHandler(project?.informationCollection?.allSummed?.workspaceCount || 0) +
          valueHandler(project?.acceptedToWork?.allSummed?.workspaceCount || 0);

        const additionalInfoCollection =
          (currentView === 'workload_by_month')
            ? 0
            : valueHandler(project?.waitingForRequest?.allSummed?.workspaceCount || 0);

        return res + baseSum + additionalInfoCollection;
      }, 0)
    );
    setAgreementWorkspaceCount(
      workloadData.reduce((res, project) => {
        return (res += valueHandler(
          project?.waitingAndAgreement?.allSummed?.workspaceCount
        ));
      }, 0)
    );

    setTotalWorkspaceCount(
      currentView === 'workload_by_month'
        ? inProgressWorkspaceCount
        : inProgressWorkspaceCount +
        finalWorkspaceCount +
        agreementWorkspaceCount +
        unassignedTotalWorkspaceCount
    );

    setInProgressPercentage(
      Math.round((inProgressWorkspaceCount / totalWorkspaceCount) * 100)
    );
    setAgreementPercentage(
      Math.round((agreementWorkspaceCount / totalWorkspaceCount) * 100)
    );
    setFinishedPercentage(
      Math.round((finalWorkspaceCount / totalWorkspaceCount) * 100)
    );
  }, [
    workloadData,
    finalWorkspaceCount,
    inProgressWorkspaceCount,
    agreementWorkspaceCount,
    totalWorkspaceCount,
    unassignedTotalWorkspaceCount,
    currentView
  ]);

  const valueHandler = (value) => (isNaN(value) ? 0 : value);


  const handleViewChange = (view) => {
    setCurrentView(view);
  };

  return (
    <main className="workspace">
      <Sidebar />
      <div className="workspace__content">


        <section className="workspace__wrapper">
          <h4 className="workspace__title workspace__page-title">
            Загруженность сотрудников &nbsp;
            <div className="workspace__table-swapper">
              <div
                style={{
                  width: 250,
                  marginTop: 30,
                }}
              >
                <Select
                  label="Год заключения договора"
                  alignLabel="left"
                  dataSrc="local"
                  value={selectedYear}
                  data={years}
                  onChange={(e) => setSelectedYear(years.values[e.target.value])}
                />
              </div>
              <TableViewSwapper onViewChange={handleViewChange} />
            </div>

            {workloadData &&
              workloadData
                .filter((data) => data.title === "Неназначенное")
                .map((data) => {
                  return (
                    <div style={{ marginTop: 20 }}>
                      <p>{data.title}:</p>
                      <p>
                        СОУТ [
                        {projectsSlashWorkspaces(
                          valueHandler(
                            data?.unassigned?.all?.sout?.projectsCount
                          ),
                          workspaceCountView(
                            valueHandler(
                              data?.unassigned?.all?.sout?.workspaceCount
                            ),
                            data?.unassigned?.all?.sout?.withX
                          )
                        )}
                        ]
                      </p>
                      <p>
                        ПК [
                        {projectsSlashWorkspaces(
                          valueHandler(
                            data?.unassigned?.all?.pk?.projectsCount
                          ),
                          workspaceCountView(
                            valueHandler(
                              data?.unassigned?.all?.pk?.workspaceCount
                            ),
                            data?.unassigned?.all?.pk?.withX
                          )
                        )}
                        ]
                      </p>
                      <p>
                        ОПР [
                        {projectsSlashWorkspaces(
                          valueHandler(
                            data?.unassigned?.all?.opr?.workspaceCount
                          ),
                          workspaceCountView(
                            valueHandler(
                              data?.unassigned?.all?.opr?.workspaceCount
                            ),
                            data?.unassigned?.all?.opr?.withX
                          )
                        )}
                        ]
                      </p>
                      <p>
                        Общее [
                        {projectsSlashWorkspaces(
                          valueHandler(
                            data?.unassigned?.allSummed?.projectsCount
                          ),
                          workspaceCountView(
                            data?.unassigned?.allSummed?.workspaceCount
                          )
                        )}
                        ]
                      </p>
                    </div>
                  );
                })}
          </h4>
          {isLoading ? (
            <Spinner />
          ) : (
            <StatisticTable tableType={currentView} projects={workloadData} />
          )}
          {!isLoading && (
            <>
              {currentView !== 'workload_by_month' && (
                <>
                  <h4>
                    В исполнении: {valueHandler(inProgressWorkspaceCount)} (
                    {inProgressPercentage}%){" "}
                    {workloadData
                      .map(
                        (el) =>
                          checkObject(el.containsX?.InformationRequest) ||
                          checkObject(el.containsX?.ReadyToWork) ||
                          checkObject(el.containsX?.AcceptedToWork)
                      )
                      .some((i) => i) && " + x"}
                  </h4>
                  <h4>
                    В согласовании: {valueHandler(agreementWorkspaceCount)} (
                    {agreementPercentage}%){" "}
                    {workloadData
                      .map((el) => el.containsX?.Agreement)
                      .some((i) => (i ? checkObject(i) : false)) && " + x"}
                  </h4>
                  <h4>
                    Завершённые: {valueHandler(finalWorkspaceCount)} (
                    {finishedPercentage}%)
                  </h4>
                </>
              )}
              <h4>
                Всего:{" "}
                {workspaceCountView(
                  valueHandler(totalWorkspaceCount),
                  workloadData.some((el) => checkObject(el.containsX))
                )}
              </h4>
            </>
          )}
        </section>
      </div>
    </main>
  );
}

export default Workload;
